<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="register-view">
    <div class="register-wrap">
      <div class="register-header">
        <div class="icon-ajuntament" />
      </div>
      <div class="register-body">
        <h2 class="register-title">{{ $t('register') }}</h2>
        <div class="title-note">{{ $t('required_field') }}</div>
        <div class="register-double-input-wrapper">
          <div class="register-input-wrapper">
            <label class="register-input-label">{{ $t('reg_name') + '*' }}</label>
            <input
              v-model="nameInput"
              class="register-input"
              :class="arrayErrorInputs.indexOf('name') !== -1 && 'error'"
              type="text"
              :placeholder="$t('reg_name_ex')"
            >
            <div v-if="arrayErrorInputs.indexOf('name') !== -1" class="error-help">{{ $t('reg_req') }}</div>
          </div>
          <div class="register-input-wrapper">
            <label class="register-input-label">{{ $t('reg_sur') + '*' }}</label>
            <input
              v-model="surnameInput"
              class="register-input"
              :class="arrayErrorInputs.indexOf('surname') !== -1 && 'error'"
              type="text"
              :placeholder="$t('reg_sur_ex')"
            >
            <div v-if="arrayErrorInputs.indexOf('surname') !== -1" class="error-help">{{ $t('reg_req') }}</div>
          </div>
        </div>
        <div class="register-double-input-wrapper">
          <div class="register-input-wrapper">
            <label class="register-input-label">{{ $t('email') + '*' }}</label>
            <input
              v-model="emailInput"
              class="register-input"
              :class="arrayErrorInputs.indexOf('email') !== -1 && 'error'"
              type="text"
              :placeholder="$t('email_ex')"
            >
            <div v-if="arrayErrorInputs.indexOf('email') !== -1" class="error-help">{{ $t('reg_email') }}</div>
          </div>
          <div class="register-input-wrapper">
            <label class="register-input-label">{{ $t('reg_email_con') }}</label>
            <input
              v-model="emailConfInput"
              class="register-input"
              :class="arrayErrorInputs.indexOf('conf-email') !== -1 && 'error'"
              type="text"
              :placeholder="$t('email_ex')"
            >
            <div v-if="arrayErrorInputs.indexOf('conf-email') !== -1" class="error-help">{{ $t('reg_email_conf') }}</div>
          </div>
        </div>
        <div class="register-double-input-wrapper">
          <div class="register-input-wrapper">
            <label class="register-input-label">{{ $t('reg_lang') }}</label>
            <select v-model="languageSel" class="register-input">
              <option value="" :label="$t('sel_placeholder')" />
              <option
                v-for="o in languageOp"
                :key="o"
                :value="o"
                :label="$t('lang_' + o)"
              />
            </select>
          </div>
          <div class="register-input-wrapper">
            <label class="register-input-label">{{ $t('reg_sex') }}</label>
            <select v-model="sexSel" class="register-input">
              <option value="NS" :label="$t('sel_placeholder')" />
              <option
                v-for="o in sexOp"
                :key="o"
                :value="o"
                :label="$t('sex_' + o)"
              />
            </select>
          </div>
        </div>
        <div class="register-double-input-wrapper">
          <div class="register-input-wrapper">
            <label class="register-input-label">{{ $t('password') + '*' }}</label>
            <input
              v-model="passInput"
              class="register-input"
              :class="arrayErrorInputs.indexOf('password') !== -1 && 'error'"
              type="password"
              :placeholder="$t('password_ex')"
            >
            <div v-if="arrayErrorInputs.indexOf('password') !== -1" class="error-help">{{ $t('reg_pass') }}</div>
            <PasswordHelp :password-input="passInput" />
          </div>
          <div class="register-input-wrapper">
            <label class="register-input-label">{{ $t('reg_pass_con') }}</label>
            <input
              v-model="passConfInput"
              class="register-input"
              :class="arrayErrorInputs.indexOf('conf-password') !== -1 && 'error'"
              type="password"
              :placeholder="$t('password_ex')"
            >
            <div v-if="arrayErrorInputs.indexOf('conf-password') !== -1" class="error-help">{{ $t('reg_pass_conf') }}</div>
          </div>
        </div>
      </div>
      <div class="register-footer">
        <div class="register-checkbox-label">{{ $t('reg_more_inf') }} <span class="link" @click="modalOpen">{{ $t('terms_and_cond') }}</span></div>
        <div class="register-checkbox-wrapper" :class="arrayErrorInputs.indexOf('consent') !== -1 && 'error-checkbox'">
          <input
            v-model="consentChecked"
            type="checkbox"
            name="check"
            class="register-checkbox-input"
          >
          <label class="register-checkbox-label">{{ $t('reg_dates_prot') }}</label>
        </div>
        <div v-if="arrayErrorInputs.indexOf('consent') !== -1" class="error-help">{{ $t('reg_check') }}</div>
        <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
        <div class="register-button" @click="validateProps">{{ $t('register') }}</div>
        <div class="login-text">{{ $t('want_login') }} <span class="link" @click="routeChange('Login')">{{ $t('login') }}</span></div>
      </div>
    </div>
    <modal
      name="modal-terms-and-conditions"
      :width="isMobile ? '90%' : '60%'"
      :height="isMobile ? '80%' : '80%'"
      :style="isMobile ? 'marginTop: 5%' : 'marginTop: 0'"
    >
      <ModalTermsAndCon :modal-close="modalClose" />
    </modal>
  </div>
</template>

<script>
import PasswordHelp from '../components/profile/PasswordHelp.vue'
import ModalTermsAndCon from '../components/modals/ModalTermsAndCon.vue'
import { registerUser } from '@/services/user-api'
export default {
  components: { ModalTermsAndCon, PasswordHelp },
  props: {},
  data() {
    return {
      nameInput: '',
      surnameInput: '',
      emailInput: '',
      emailConfInput: '',
      languageSel: '',
      sexSel: 'NS',
      passInput: '',
      passConfInput: '',
      languageOp: ['ca', 'es', 'en'],
      sexOp: ['M', 'F'],
      consentChecked: false,
      //arrayErrorInputs = name, surname, email, conf-email, password, conf-password, terms, consent
      arrayErrorInputs: [],
      errorMsg: '',
    }
  },
  computed: {},
  watch: {
    nameInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('name') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('name'), 1)
      }
    },
    surnameInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('surname') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('surname'), 1)
      }
    },
    emailInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('email') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('email'), 1)
      }
      if (this.arrayErrorInputs.indexOf('conf-email') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('conf-email'), 1)
      }
    },
    emailConfInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('conf-email') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('conf-email'), 1)
      }
    },
    passConfInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('conf-password') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('conf-password'), 1)
      }
    },
    consentChecked() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('consent') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('consent'), 1)
      }
    },
    passInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('password') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('password'), 1)
      }
      if (this.arrayErrorInputs.indexOf('conf-password') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('conf-password'), 1)
      }
    },
  },
  methods: {
    /**
     * Update the current route with new params if current page is different
     * @param {String} routeName Name of page that user want's to navigate
     * @public This is a public method
     */
    routeChange(routeName) {
      if (this.$route.name !== routeName) this.$router.push({ name: routeName })
    },
    modalOpen() {
      this.$modal.show('modal-terms-and-conditions')
    },
    modalClose() {
      this.$modal.hide('modal-terms-and-conditions')
    },
    emailValidation() {
      let reg = /[^\s]*@[a-z0-9.-]*/i
      return this.emailInput === this.emailConfInput && reg.test(this.emailInput)
    },
    validateProps() {
      if (this.nameInput === '' && this.arrayErrorInputs.indexOf('name') === -1) {
        this.arrayErrorInputs.push('name')
      }
      if (this.surnameInput === '' && this.arrayErrorInputs.indexOf('surname') === -1) {
        this.arrayErrorInputs.push('surname')
      }
      let reg = /[^\s]*@[a-z0-9.-]*/i
      if (
        (this.emailInput === '' || !reg.test(this.emailInput)) &&
        this.arrayErrorInputs.indexOf('email') === -1
      ) {
        this.arrayErrorInputs.push('email')
      }
      if (
        (this.emailInput !== this.emailConfInput || this.emailConfInput === '') &&
        this.arrayErrorInputs.indexOf('conf-email') === -1
      ) {
        this.arrayErrorInputs.push('conf-email')
      }
      //check del password
      let regex1 = /[A-Z]/
      let regex2 = /[a-z]/
      let regex3 = /\d/
      if (
        (this.passInput.length < 8 ||
          !regex1.test(this.passInput) ||
          !regex2.test(this.passInput) ||
          !regex3.test(this.passInput)) &&
        this.arrayErrorInputs.indexOf('password') === -1
      ) {
        this.arrayErrorInputs.push('password')
      }
      if (
        (this.passInput !== this.passConfInput || this.passConfInput === '') &&
        this.arrayErrorInputs.indexOf('conf-password') === -1
      ) {
        this.arrayErrorInputs.push('conf-password')
      }
      if (!this.consentChecked && this.arrayErrorInputs.indexOf('consent') === -1) {
        this.arrayErrorInputs.push('consent')
      }
      if (this.arrayErrorInputs.length === 0) {
        registerUser(
          this.nameInput,
          this.surnameInput,
          this.emailInput,
          this.passInput,
          this.languageSel === '' ? 'ca' : this.languageSel,
          this.sexSel,
          this.consentChecked
          // this.termsChecked,
        )
          .then(resp => {
            console.log(resp)
            this.$store
              .dispatch('saveUserEmail', this.emailInput)
              .then(() => this.$router.push({ name: 'Validate' }))
          })
          .catch(err => {
            if (err.response.data.code === 400) {
              this.errorMsg = err.response.data.error
            }
          })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.register-view
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  padding: vw(30px)
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)
  background-color: $very-light-grey

.register-wrap
  padding: vh(20px) vw(24px)
  width: vw(800px)
  border-radius: 8px
  background-color: #fff
  box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)

  .mobile &
    width: 100%

.register-header
  display: flex
  justify-content: space-between
  margin-bottom: vw(25px)

  .icon-ajuntament
    width: 176px
    height: 45px
    background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
    background-position: center center
    background-size: cover
    background-repeat: no-repeat

.register-title
  m-font-size(32, 45)
  margin-block-start: 0
  margin-block-end: vh(10px)
  color: $base-font-color
  font-weight: 600

.register-footer
  display: flex
  flex-direction: column
  margin-top: vh(23px)
  padding-top: vh(15px)
  border-top: 1px solid $grey-grey
  gap: vw(10px)

  .mobile &
    margin-top: 20px
    padding-top: 20px

  .error-help
    margin-bottom: vh(8px)

.register-button
  m-font-size(14, 20)
  display: inline-block
  margin-top: vh(10px)
  width: max-content
  margin-bottom: vh(20px)
  padding: vw(10px)
  border-radius: 4px
  background-color: #000
  color: #fff
  cursor: pointer

.register-checkbox-wrapper
  display: flex
  align-items: flex-start
  padding-top: vh(10px)
  padding-bottom: vh(6px)
  gap: vw(10px)

  &.error-checkbox
    border: 2px solid $warning

.register-double-input-wrapper
  display: flex
  justify-content: space-between
  gap: vw(24px)

  &:last-child
    margin-bottom: vh(-36px)

  .mobile &
    flex-direction: column
    gap: vw(10px)

.register-input-wrapper
  margin-bottom: vh(36px)
  width: 100%

.register-input-label
  m-font-size(14, 20)
  display: block
  margin-bottom: vh(8px)
  color: $grey

.register-input
  position: relative
  padding: 0
  padding-right: vw(12px)
  padding-left: vw(12px)
  width: 100%
  height: vh(48px)
  outline: none
  border: 1px solid $grey
  border-radius: 4px
  background-color: $light-grey
  color: #000
  font-weight: 600

  .mobile &
    height: vw(40px)

  &::placeholder
    color: $grey
    font-weight: 400

  &.error
    border: 2px solid $warning

.link
  color: $corporate_color
  cursor: pointer

  &:hover
    text-decoration: underline

.register-checkbox-label
  m-font-size(14, 18)
  color: $grey-dark

.error-help
  m-font-size(12, 16)
  margin-top: vh(4px)
  color: $warning

.error-msg
  m-font-size(16, 20)
  margin-top: vh(20px)
  margin-bottom: vh(20px)
  color: $warning
  font-weight: 600

.login-text
  m-font-size(12, 16)
  color: #000

.title-note
  m-font-size(14, 18)
  margin-bottom: vh(20px)

.register-checkbox-input
  margin: 3px 0
</style>